import styled from 'styled-components';

export const ArticleWrapper = styled.div`
  color: #fff;
  background-color: ${({ overlay }) => overlay};
  margin-bottom: 1em;
  border-radius: 3px;
  font-family: "Montserrat", cursive;
  width: 90%;
  max-width: 90%;
  text-align: center;
  font-weight: 700;

  :first-child {
    margin-top: 1em;
  }
  
  a {
    color: #fff;
    text-decoration: none;
    padding: 1em 2em;
    display: block;
  }
`;